import useLogin from "./useLogin"

const LoginPage = () => {
    const {
        form,
        baseUrl,
        status,
        error,
        loginType,
        handleSubmit,
        handleChange,
        handleChangeLoginType,
    } = useLogin()

    return (
        <main>
            <div className="container">
                <section className="section register min-vh-100 d-flex flex-column align-items-center justify-content-center py-4">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-4 col-md-6 d-flex flex-column align-items-center justify-content-center">
                                <div className="d-flex flex-column justify-content-center py-4">
                                </div>
                                {status === 'succeeded' &&
                                    <div>
                                        <div className="alert alert-success alert-dismissible fade show" role="alert">
                                            <i className="bi bi-exclamation-octagon me-1"></i>
                                            Login successful!
                                            <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                                        </div>
                                    </div>
                                }
                                <div className="card mb-3">
                                    <div className="card-body auth-login">
                                        <div className="pt-4 pb-4 ">
                                            <div className="d-flex flex-row justify-content-center">
                                                <img src={`${baseUrl}/assets/img/kemenag_logo_mini.png`} style={{ width: "100px", height: "auto" }} alt="" />
                                            </div>
                                            <h5 className="card-title text-center pb-0 fs-4">E-Office Web App</h5>
                                            <p className="text-center small">Login to your account! </p>
                                            <br />
                                            {status === 'failed' &&
                                                <div>
                                                    <div className="alert alert-danger alert-dismissible fade show" role="alert">
                                                        <i className="bi bi-exclamation-octagon me-1"></i>
                                                        {error.message || 'Login failed. Please try again.'}
                                                        <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                                                    </div>
                                                </div>
                                            }
                                            <ul className="nav nav-pills nav-justified">
                                                <li className="nav-item">
                                                    <div className={`nav-link left ${loginType === "pegawai" ? "active" : ""}`} aria-current="page" onClick={() => handleChangeLoginType("pegawai")}>Pegawai/Pejabat</div>
                                                </li>
                                                <li className="nav-item">
                                                    <div className={`nav-link right ${loginType === "admin" ? "active" : ""}`} aria-current="page" onClick={() => handleChangeLoginType("admin")}>Admin</div>
                                                </li>
                                            </ul>
                                        </div>
                                        <form className="row g-3 needs-validation" onSubmit={handleSubmit} noValidate>
                                            {
                                                loginType === "pegawai" ? <div className="col-12">
                                                    <label htmlFor="nip" className="form-label">NIP/Email</label>
                                                    <div className="input-group has-validation">
                                                        <input type="text" name="nip" value={form.nip} className="form-control" id="nip" onChange={handleChange} required />
                                                        <div className="invalid-feedback">Please enter your NIP/Email.</div>
                                                    </div>
                                                </div> : <div className="col-12">
                                                    <label htmlFor="email" className="form-label">Email</label>
                                                    <div className="input-group has-validation">
                                                        <input type="text" name="email" value={form.email} className="form-control" id="email" onChange={handleChange} required />
                                                        <div className="invalid-feedback">Please enter your email.</div>
                                                    </div>
                                                </div>
                                            }
                                            <div className="col-12">
                                                <label htmlFor="password" className="form-label">Password</label>
                                                <input type="password" name="password" value={form.password} className="form-control" id="password" onChange={handleChange} required />
                                                <div className="invalid-feedback">Please enter your password!</div>
                                            </div>

                                            <div className="col-12">
                                                <button className="btn btn-primary w-100 py-2" type="submit">Login</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>

                                <div className="credits">
                                    Designed by <a href="#">PUSDATIN</a>
                                </div>
                            </div>
                        </div>
                    </div>

                </section>

            </div>
        </main>
    )
}
export default LoginPage